import { NarrativeAuthorAvatar } from '@/components/NarrativeAuthor';
import { useNarrativeById } from '@/components/NarrativeCard/hooks/useNarrativeById';
import { Bones } from '../../../Bones';
import type { ReactNode } from 'react';

const Layout = ({ children }: { children?: ReactNode }) => (
  <div className="relative size-x2 overflow-hidden rounded-full bg-legacy-darkergray/50 shadow-sm [&_>*]:size-full">
    {children}
  </div>
);

export const NarrativeAvatar = ({ narrativeId }: { narrativeId: string }) => {
  const { data, status } = useNarrativeById({ narrativeId });
  const narrative = data?.NarrativeById;

  if (status === 'pending')
    return (
      <Layout>
        <Bones className="bg-legacy-darkgray/50" />
      </Layout>
    );

  if (status === 'error') return;
  if (!narrative) return;

  return (
    <Layout>
      <NarrativeAuthorAvatar size="sm" author={narrative?.author} />
    </Layout>
  );
};
